"use strict";

/* ============================================================
   ABR product page — Suitsupply-style size selector
   Variants arrive as JSON in #pp-variant-data:
   [{id, title, available, price}]
   Titles like "40", "40R", "40L", "40S" are grouped into
   Regular / Long / Short columns, aligned by numeric size.
   Sold-out sizes offer the made-to-measure (custom) path.
   ============================================================ */
(function () {
  var modal = document.getElementById("size-modal");
  if (!modal) return;

  var dataEl = document.getElementById("pp-variant-data");
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  var grid = modal.querySelector(".sz-grid");
  var addBtn = modal.querySelector("#sz-add");
  var note = modal.querySelector(".sz-custom-note");
  var form = document.getElementById("pp-form");
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var openBtns = document.querySelectorAll("[data-open-size]");
  var selected = null;

  var SIZE_LABELS = { "32": "XXS", "34": "XS", "36": "S", "38": "M", "40": "M/L", "42": "L", "44": "XL", "46": "XXL", "48": "3XL", "50": "4XL", "52": "5XL", "54": "6XL", "56": "7XL", "58": "8XL" };

  /* ---- parse variants into sizes: num -> {base, long, short} ---- */
  var sizes = {};   /* one option:  "40" / "40R"  -> { base, long, short }   */
  var pairs = {};   /* two options: "40 / 32"     -> pairs[jacket][waist]    */
  var nonNumeric = [];
  variants.forEach(function (v) {
    var t = String(v.title).trim();
    /* Jacket × Pants products arrive as "40 / 32". Without this they fell
       through to the flat list and lost the fit/length/inseam rows. */
    var p = t.match(/^(\d{2})\s*\/\s*(\d{2})$/);
    if (p) {
      pairs[p[1]] = pairs[p[1]] || {};
      pairs[p[1]][p[2]] = v;
      return;
    }
    var m = t.match(/^(\d{2})\s*(R|L|S)?$/i);
    if (!m) { nonNumeric.push(v); return; }
    var num = m[1];
    var suf = (m[2] || "R").toUpperCase();
    sizes[num] = sizes[num] || {};
    sizes[num][suf === "L" ? "long" : suf === "S" ? "short" : "base"] = v;
  });

  var pairJackets = Object.keys(pairs).sort(function (a, b) { return a - b; });
  var hasPants = pairJackets.length > 0;          /* waist is a real variant */
  var numKeys = hasPants ? pairJackets : Object.keys(sizes).sort(function (a, b) { return a - b; });
  var isSuit = numKeys.length > 0;

  /* Jackets/blazers sold on their own get no pants rows. If the product
     genuinely has a pants variant, the waist drives the variant and must
     stay regardless of what the template guessed. */
  var jacketOnly = modal.dataset.jacketOnly === "true";
  if (hasPants) jacketOnly = false;

  /* Every waist offered across all jackets, ascending. */
  var pairWaists = [];
  if (hasPants) {
    var seenW = {};
    pairJackets.forEach(function (j) { Object.keys(pairs[j]).forEach(function (w) { seenW[w] = 1; }); });
    pairWaists = Object.keys(seenW).sort(function (a, b) { return a - b; });
  }

  var selNum = null, selCut = "Classic", selLen = "Regular";
  var FITS = [
    { id: "Slim", note: "" },
    { id: "Classic", note: "Most Popular" },
    { id: "Athletic", note: "" }
  ];
  var selWaist = null, selInseam = null;
  var WAISTS = [
    ["28","XS"],["29","XS"],["30","S"],["31","S"],["32","M"],["33","M"],
    ["34","L"],["35","L"],["36","XL"],["38","2XL"],["40","3XL"],["42","4XL"]
  ];
  /* Height bands are continuous and open-ended at both ends \u2014 the old ones
     overlapped (5\u203211\u2033 and 6\u20321\u2033 each appeared twice) and stopped at 6\u20323\u2033, so a
     taller or shorter customer couldn't find themselves. */
  var INSEAMS = [
    ["27","Under 5\u20326\u2033"],["28","5\u20326\u2033\u20135\u20327\u2033"],
    ["29","5\u20328\u2033\u20135\u20329\u2033"],["30","5\u203210\u2033\u20135\u203211\u2033"],
    ["31","6\u20320\u2033"],["32","6\u20321\u2033\u20136\u20322\u2033"],
    ["33","6\u20323\u2033"],["34","6\u20324\u2033 and up"]
  ];
  var LENGTHS = [
    { id: "Short", note: "Under 5\u20329\u2033" },
    { id: "Regular", note: "5\u20329\u2033\u20135\u203210\u2033" },
    { id: "Tall", note: "5\u203211\u2033\u20136\u20320\u2033" },
    { id: "Very Tall", note: "6\u20321\u2033 and up" }
  ];

  function build() {
    grid.classList.add("szp");
    var html = "";
    if (isSuit) {
      html += '<h3 class="szp-label">Jacket Size</h3><div class="szp-row cols-3" data-group="size">';
      numKeys.forEach(function (num) {
        var s = sizes[num] || {};
        var anyAvailable = hasPants
          ? Object.keys(pairs[num]).some(function (w) { return pairs[num][w].available; })
          : ["base", "long", "short"].some(function (k) { return s[k] && s[k].available; });
        if (anyAvailable) {
          html += '<div class="szp-cell"><button type="button" class="size-btn" data-num="' + num + '">' + num + '</button><small>' + (SIZE_LABELS[num] || "&nbsp;") + '</small></div>';
        } else {
          html += '<div class="szp-cell"><button type="button" class="size-btn soldout" data-custom="1">' + num + '<small>Custom made</small></button><small>' + (SIZE_LABELS[num] || "&nbsp;") + '</small></div>';
        }
      });
      html += '</div>';
      html += '<h3 class="szp-label">Fit</h3><div class="szp-row cols-3" data-group="fit">';
      FITS.forEach(function (f) {
        html += '<div class="szp-cell"><button type="button" class="size-btn' + (f.id === selCut ? " selected" : "") + '" data-cut="' + f.id + '">' + f.id + '</button><small>' + (f.note || "&nbsp;") + '</small></div>';
      });
      html += '</div>';
      html += '<h3 class="szp-label">Length</h3><div class="szp-row cols-4" data-group="length">';
      LENGTHS.forEach(function (l) {
        html += '<div class="szp-cell"><button type="button" class="size-btn' + (l.id === selLen ? " selected" : "") + '" data-len="' + l.id + '">' + l.id + '</button><small>' + l.note + '</small></div>';
      });
      html += '</div>';
      /* When the product carries a real pants option the waist picks the
         variant, so it's required. Otherwise it's a free-hemming note.
         Jacket/blazer-only products skip both pants rows entirely. */
      if (jacketOnly) {
        /* no pants rows */
      } else if (hasPants) {
        html += '<h3 class="szp-label">Pants \u2014 Waist <span class="szp-opt">Required</span></h3><div class="szp-row cols-4" data-group="waist">';
        pairWaists.forEach(function (w) {
          var lbl = (WAISTS.filter(function (x) { return x[0] === w; })[0] || [])[1] || "&nbsp;";
          html += '<div class="szp-cell"><button type="button" class="size-btn" data-waist="' + w + '">' + w + '</button><small>' + lbl + '</small></div>';
        });
        html += '</div>';
      } else {
        html += '<h3 class="szp-label">Pants \u2014 Waist <span class="szp-opt">Optional \u00b7 fitted free</span></h3><div class="szp-row cols-4" data-group="waist">';
        WAISTS.forEach(function (w) {
          html += '<div class="szp-cell"><button type="button" class="size-btn" data-waist="' + w[0] + '">' + w[0] + '</button><small>' + w[1] + '</small></div>';
        });
        html += '</div>';
      }
      /* Inseam row removed for now (kept INSEAMS + handlers for easy restore). */
    } else {
      html += '<h3 class="szp-label">Size</h3><div class="szp-row cols-3" data-group="size">';
      variants.forEach(function (v) {
        if (v.available) {
          html += '<div class="szp-cell"><button type="button" class="size-btn" data-id="' + v.id + '" data-title="' + v.title + '">' + v.title + '</button><small>&nbsp;</small></div>';
        } else {
          html += '<div class="szp-cell"><button type="button" class="size-btn soldout" data-custom="1">' + v.title + '<small>Custom made</small></button><small>&nbsp;</small></div>';
        }
      });
      html += '</div>';
    }
    grid.innerHTML = html;
  }

  /* Resolve the real variant for size + length: use a stocked 40L/40S when it
     exists, otherwise the base size — ABR tailors the length free. */
  /* Grey out waists this jacket size doesn't come in. */
  function refreshWaists() {
    if (!hasPants) return;
    var row = grid.querySelector('[data-group="waist"]');
    if (!row) return;
    row.querySelectorAll(".size-btn").forEach(function (b) {
      var w = b.dataset.waist;
      var ok = selNum ? !!(pairs[selNum] && pairs[selNum][w] && pairs[selNum][w].available) : true;
      b.classList.toggle("soldout", !ok);
      b.disabled = !ok;
      if (!ok && b.classList.contains("selected")) {
        b.classList.remove("selected");
        selWaist = null;
      }
    });
  }

  function resolve() {
    if (!isSuit || !selNum) return null;
    if (hasPants) {
      if (!selWaist) return null;
      var pv = pairs[selNum] && pairs[selNum][selWaist];
      if (!pv || !pv.available) return null;
      return { v: pv, lengthAltered: selLen !== "Regular" };
    }
    var s = sizes[selNum];
    var want = selLen === "Short" ? "short" : (selLen === "Tall" || selLen === "Very Tall") ? "long" : "base";
    var exact = s[want] && s[want].available ? s[want] : null;
    var v = exact || (s.base && s.base.available ? s.base : null) || null;
    if (!v) return null;
    return { v: v, lengthAltered: selLen !== "Regular" && (!exact || selLen === "Very Tall") };
  }

  function updateState() {
    if (!isSuit) return;
    var r = resolve();
    if (selNum && r) {
      addBtn.disabled = false;
      var parts = [selNum];
      if (hasPants && selWaist) parts.push("W" + selWaist);
      if (selCut !== "Classic") parts.push(selCut);
      if (selLen !== "Regular") parts.push(selLen);
      addBtn.textContent = "Add to Bag \u2014 " + parts.join(" \u00b7 ");
      if (r.v.price) { var priceEl = modal.querySelector(".sz-price"); if (priceEl) priceEl.textContent = r.v.price; }
    } else {
      addBtn.disabled = true;
      addBtn.textContent = "Add to Bag";
    }
  }

  function open() {
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function close() {
    modal.classList.remove("open");
    document.body.style.overflow = "";
  }

  build();
  openBtns.forEach(function (b) { b.addEventListener("click", open); });
  modal.querySelector(".sz-backdrop").addEventListener("click", close);
  modal.querySelector(".sz-close").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  grid.addEventListener("click", function (e) {
    var btn = e.target.closest(".size-btn");
    if (!btn) return;

    if (btn.dataset.custom) {
      note.classList.add("show");
      note.innerHTML = 'That size is out of stock \u2014 but the Atelier will make it <strong>to your exact measurements</strong> from $495. <a href="/pages/made-to-measure">Have it custom made \u2192</a>';
      var g = btn.closest("[data-group]");
      if (g) g.querySelectorAll(".size-btn.selected").forEach(function (x) { x.classList.remove("selected"); });
      selNum = null; selected = null;
      updateState();
      if (!isSuit) addBtn.disabled = true;
      return;
    }
    note.classList.remove("show");

    var wasSelected = btn.classList.contains("selected");
    var group = btn.closest("[data-group]");
    if (group) group.querySelectorAll(".size-btn.selected").forEach(function (x) { x.classList.remove("selected"); });
    btn.classList.add("selected");

    if (btn.dataset.num) { selNum = btn.dataset.num; refreshWaists(); }
    else if (btn.dataset.cut) { selCut = btn.dataset.cut; }
    else if (btn.dataset.len) { selLen = btn.dataset.len; }
    else if (btn.dataset.waist) {
      /* Required when it drives the variant, so it can't be toggled off. */
      if (hasPants) { selWaist = btn.dataset.waist; }
      else { selWaist = wasSelected ? null : btn.dataset.waist; if (wasSelected) btn.classList.remove("selected"); }
    }
    else if (btn.dataset.inseam) { selInseam = wasSelected ? null : btn.dataset.inseam; if (wasSelected) btn.classList.remove("selected"); }
    else if (btn.dataset.id) {
      selected = btn.dataset.id;
      addBtn.disabled = false;
      addBtn.textContent = "Add to Bag \u2014 " + (btn.dataset.title || btn.textContent.trim());
      return;
    }
    updateState();
  });

  addBtn.addEventListener("click", function () {
    var variantId = selected;
    var lengthProp = null, cutProp = null;
    if (isSuit) {
      var r = resolve();
      if (!r) return;
      variantId = r.v.id;
      if (r.lengthAltered) lengthProp = selLen + " \u2014 length tailored free by ABR";
      if (selCut !== "Classic") cutProp = selCut + " Fit \u2014 tapered free by ABR";
    }
    if (!variantId) return;
    if (form && idInput) {
      idInput.value = variantId;
      var setProp = function (name, value) {
        var input = form.querySelector('input[name="properties[' + name + ']"]');
        if (value) {
          if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = "properties[" + name + "]";
            form.appendChild(input);
          }
          input.value = value;
        } else if (input) {
          input.remove();
        }
      };
      setProp("Length", lengthProp);
      setProp("Cut", cutProp);
      /* When waist is a real variant it's already on the line item \u2014 only
         record it as a property when it's just a tailoring instruction. */
      setProp("Pants waist", (!hasPants && selWaist) ? selWaist + '\u2033 \u2014 hemmed free by ABR' : null);
      setProp("Pants inseam", selInseam ? selInseam + '\u2033 \u2014 hemmed free by ABR' : null);
      form.submit();
    } else {
      addBtn.textContent = "Added \u2713";
      setTimeout(close, 700);
    }
  });

  /* Gallery: vertical stack on desktop, horizontal swipe carousel on mobile */
  var gal = document.querySelector(".pp-gallery");
  var galImgs = gal ? gal.querySelectorAll(".pp-img") : [];
  function galleryIsCarousel() { return gal && gal.scrollWidth > gal.clientWidth + 10; }
  function goToImage(i) {
    if (!galImgs[i]) return;
    if (galleryIsCarousel()) {
      gal.scrollTo({ left: i * gal.clientWidth, behavior: "smooth" });
    } else {
      galImgs[i].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  /* Mobile dots under the gallery */
  var dotsBox = document.getElementById("pp-dots");
  if (gal && dotsBox && galImgs.length > 1) {
    var dots = [];
    galImgs.forEach(function (_, i) {
      var d = document.createElement("button");
      d.type = "button";
      d.setAttribute("aria-label", "Image " + (i + 1));
      if (i === 0) d.classList.add("active");
      d.addEventListener("click", function () { goToImage(i); });
      dotsBox.appendChild(d);
      dots.push(d);
    });
    gal.addEventListener("scroll", function () {
      var idx = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle("active", i === idx); });
    }, { passive: true });
  }

  /* Swatch thumbnails jump the gallery to that image */
  document.querySelectorAll(".pp-swatch").forEach(function (sw, i) {
    sw.addEventListener("click", function () {
      document.querySelectorAll(".pp-swatch").forEach(function (x) { x.classList.remove("active"); });
      sw.classList.add("active");
      goToImage(i);
    });
  });

  /* Wishlist toggle (visual) */
  var wish = document.querySelector(".pp-wish");
  if (wish) wish.addEventListener("click", function () { wish.classList.toggle("on"); wish.textContent = wish.classList.contains("on") ? "♥" : "♡"; });
})();
